import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../../modules/SimpleInput";
import InventoryUnitTable from "./InventoryUnitTable";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import {fetchCardStockDetail, getTableStockCardDetailConfig} from "../service";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { defaultTableChange } from "../../../../../modules/custom/customTable";

class InventoryPageStockInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            dataTable: [],
            pagination: {
                count: 0,
                limit: 5,
                page: 1,
                orderBy: "id",
                sort: "ASC",
            },
        }
    };

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchData();
        this.handleTriggerLoading();
    };

    fetchData = async () => {
        let {selectedData, kodeCabang, kodeLocator, kodeKSU, transactionType, type, setError, selectedParentData} = this.props;
        let request = {
            kodeKSU,
            kodeLocator,
            kodeCabang,
            transactionType,
            stockDate: type == 'hadiah' || type == 'otherItem' ? selectedData.date : selectedData.stockCardDate,
        };
        await fetchCardStockDetail(
            type,
            this.setState.bind(this),
            request,
            setError,
            selectedParentData
        );
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({...prevValue, loading: !prevValue.loading}))
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        let { type, selectedParentData, selectedData } = this.props;
        const dynamicTableConfig = getTableStockCardDetailConfig(type, selectedParentData);
        let dateValue = type == 'hadiah' || type == 'otherItem' ? selectedData.date : selectedData.stockCardDate

        let modalTitle = "Detail Stock Info";
        if (type === "hadiah") {
            modalTitle = selectedParentData?.qr
                ? "Detail Stock Info (Dengan QR)"
                : "Detail Stock Info (Tanpa QR)";
        }
        return (
            <SimpleModal
                title={modalTitle}
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                        <div className="grid grid-3x grid-mobile-none gap-20px margin-bottom-20px">
                            <div id="grid-1">
                                <SimpleInput
                                    id="input_text_kode_variant"
                                    name="tglTransaksi"
                                    label="Tanggal"
                                    readOnly={true}
                                    value={dateValue}
                                />
                            </div>
                        </div>
                        <SimpleDataTable
                          key={`${this.state.pagination.count}-${this.state.pagination.page}`}
                          data={this.state.dataTable}
                          columns={dynamicTableConfig}
                          toCount={this.state.pagination.count}
                          rowsPerPage={this.state.pagination.limit}
                          page={this.state.pagination.page - 1}
                          options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                        />
                        <div style={{textAlign: "right", marginTop: "10px"}}>
                            <SimpleButton
                                onClick={() => this.props.onClickClose()}
                                secondary
                                text={"Kembali"}
                            />
                        </div>
                        <SimpleLoadingOverlay active={this.state.loading}/>
                    </ModalContainer>
                }
            />
        )
    }
}

export default InventoryPageStockInfo;